<template>
  <section class="sa-chart-card" :class="{ 'sa-chart-card--emphasis': emphasis }">
    <div class="sa-chart-card__head">
      <h3 class="sa-chart-card__title">{{ title }}</h3>
      <p v-if="subtitle" class="sa-chart-card__subtitle">{{ subtitle }}</p>
    </div>
    <div class="sa-chart-card__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'DashboardChartCard',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    emphasis: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.sa-chart-card {
  background: var(--dashboard-card, #fff);
  border: 1px solid var(--dashboard-border, #e8eaf0);
  border-radius: 14px;
  padding: 1.15rem 1.2rem 1rem;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sa-chart-card--emphasis {
  min-height: 100%;
}

.sa-chart-card__head {
  margin-bottom: 0.5rem;
}

.sa-chart-card__title {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--dashboard-text, #191c24);
}

.sa-chart-card__subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.75rem;
  color: var(--dashboard-muted, #697386);
}

.sa-chart-card__body {
  flex: 1;
  min-width: 0;
  width: 100%;
}
</style>
